import React from "react";
import { Construction } from "lucide-react";

export const Placeholder = ({ title, subtitle, testid }) => (
  <div className="h-full flex flex-col" data-testid={testid}>
    <div className="px-4 py-2 border-b border-border">
      <h1 className="font-display font-black uppercase tracking-tight text-lg leading-none">{title}</h1>
      <div className="micro-label mt-1">{subtitle}</div>
    </div>
    <div className="flex-1 grid-bg flex items-center justify-center">
      <div className="panel p-6 max-w-md text-center">
        <Construction className="w-8 h-8 mx-auto sev-medium" strokeWidth={1.5} />
        <div className="mt-3 font-display font-bold uppercase tracking-tight">Module scheduled</div>
        <p className="mt-2 text-xs text-muted-foreground">
          This module is part of the next delivery phase. Phase 1 ships the Command Center,
          live alert rail and mock event engine.
        </p>
      </div>
    </div>
  </div>
);

export default Placeholder;
